import { createApiAction } from 'src/api';

export const ADD_PRODUCT_START = 'account/add_product_start';
export const ADD_PRODUCT_SUCCESS = 'account/add_product_success';
export const ADD_PRODUCT_FAILURE = 'account/add_product_failure';

export const UPDATE_PRODUCT_START = 'account/update_product_start';
export const UPDATE_PRODUCT_SUCCESS = 'account/update_product_success';
export const UPDATE_PRODUCT_FAILURE = 'account/update_product_failure';

export const DELETE_PRODUCT_START = 'account/delete_product_start';
export const DELETE_PRODUCT_SUCCESS = 'account/delete_product_success';
export const DELETE_PRODUCT_FAILURE = 'account/delete_product_failure';

export const ADD_PRODUCT_COA_START = 'account/add_product_coa_start';
export const ADD_PRODUCT_COA_SUCCESS = 'account/add_product_coa_success';
export const ADD_PRODUCT_COA_FAILURE = 'account/add_product_coa_failure';

export const DELETE_PRODUCT_COA_START = 'account/delete_product_coa_start';
export const DELETE_PRODUCT_COA_SUCCESS = 'account/delete_product_coa_success';
export const DELETE_PRODUCT_COA_FAILURE = 'account/delete_product_coa_failure';

export const addAccountProduct = ({
  accountId,
  name,
  productSKU,
  batchNumber,
  expirationDate,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/products/`,
      method: 'POST',
      body: {
        product_product_name: name,
        product_sku: productSKU,
        product_batch_number: batchNumber,
        product_expiration_date: expirationDate,
        product_link_to_coa: 'https://google.com',
      },
    },
    [ADD_PRODUCT_START, ADD_PRODUCT_SUCCESS, ADD_PRODUCT_FAILURE]
  );

export const updateAccountProduct = ({
  accountId,
  productId,
  name,
  productSKU,
  batchNumber,
  expirationDate,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/products/${productId}/`,
      method: 'PUT',
      body: {
        product_product_name: name,
        product_sku: productSKU,
        product_batch_number: batchNumber,
        product_expiration_date: expirationDate,
        product_link_to_coa: 'https://google.com',
      },
    },
    [UPDATE_PRODUCT_START, UPDATE_PRODUCT_SUCCESS, UPDATE_PRODUCT_FAILURE]
  );

export const deleteAccountProduct = ({ accountId, productId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/products/${productId}/`,
      method: 'DELETE',
    },
    [DELETE_PRODUCT_START, DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_FAILURE]
  );
};

export const addAccountProductCOA = ({ accountId, productId, file }) => {
  const formData = new FormData();
  formData.append('product_coa_file', file);

  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/products/${productId}/coas/`,
      method: 'POST',
      formData,
    },
    [ADD_PRODUCT_COA_START, ADD_PRODUCT_COA_SUCCESS, ADD_PRODUCT_COA_FAILURE]
  );
};

export const deleteAccountProductCOA = ({ accountId, productId, coaId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/products/${productId}/coas/${coaId}/`,
      method: 'DELETE',
    },
    [
      DELETE_PRODUCT_COA_START,
      DELETE_PRODUCT_COA_SUCCESS,
      DELETE_PRODUCT_COA_FAILURE,
    ]
  );
};
